import { TableFilter, TTableFilter } from '@components/table/types';
import { PolicySearchField } from '@models/policy';
import { policyStatusFilterOptions } from '@components/table/filters/PolicyStatusFilter';

export const getPolicyFilters = ({ isInternalUser }: { isInternalUser: boolean }): TTableFilter[] => [
  {
    field: PolicySearchField.Status,
    label: 'Policy Status',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.POLICY_STATUS_FILTER,
    other: {
      options: policyStatusFilterOptions,
    },
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.Product,
    label: 'Product',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.OFFERING_TYPEAHEAD,
    childrenFields: [PolicySearchField.ProductOption, PolicySearchField.ProductLabel],
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.ProductOption,
    label: 'Business Class',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.BUSINESS_CLASS_TYPEAHEAD,
    watchedField: PolicySearchField.Product,
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.ProductLabel,
    label: 'Product Label',
    width: { gridWidth: { xs: 12 } },
    watchedField: PolicySearchField.Product,
    type: TableFilter.PRODUCT_LABEL_TYPEAHEAD,
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.WritingCompany,
    label: 'Writing Company',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.WRITING_COMPANY_TYPEAHEAD,
  },
  {
    field: PolicySearchField.UpdatedDate,
    label: 'Updated Date',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.DATE_RANGE,
    fieldConfig: {
      dateRangeField: {
        displayMode: 'horizontal',
      },
    },
  },
  {
    field: PolicySearchField.EffectiveDate,
    label: 'Effective Date',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.DATE_RANGE,
    fieldConfig: {
      dateRangeField: {
        displayMode: 'horizontal',
      },
    },
  },
  {
    field: PolicySearchField.Underwriter,
    label: 'Underwriter',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.UNDERWRITER_TYPEAHEAD_FILTER,
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.Brokerage,
    label: 'Brokerage',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.BROKERAGE_TYPEAHEAD,
    childrenFields: [PolicySearchField.Producer],
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.Producer,
    label: 'Producer',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.BROKERAGE_PRODUCER_TYPEAHEAD,
    watchedField: PolicySearchField.Brokerage,
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  {
    field: PolicySearchField.PackageLabel,
    label: 'Line of Business',
    width: { gridWidth: { xs: 12 } },
    type: TableFilter.LINE_OF_BUSINESS_TYPEAHEAD,
    fieldConfig: {
      selectField: {
        multiSelect: true,
      },
    },
  },
  ...(isInternalUser
    ? [
        {
          field: PolicySearchField.QuoteSource,
          label: 'Quote Source',
          width: { gridWidth: { xs: 12 } },
          type: TableFilter.REPORTING_QUOTE_SOURCE_TYPEAHEAD,
          fieldConfig: {
            selectField: {
              multiSelect: true,
            },
          },
        } as TTableFilter,
        {
          field: PolicySearchField.PendingBORTransfer,
          label: 'BOR Transfer Status',
          width: { gridWidth: { xs: 12 } },
          type: TableFilter.SELECT_SINGLE,
          other: {
            options: [
              { value: 'Pending', label: 'Pending' },
              { value: 'Completed', label: 'Completed' },
              { value: 'Cancelled', label: 'Cancelled' },
            ],
          },
        } as TTableFilter,
      ]
    : []),
];
